import { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import BuyerWaitlist from "@/pages/BuyerWaitlist";
import BecomeVendor from "@/pages/BecomeVendor";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import CategoryPage from "@/pages/CategoryPage";
import RestaurantSignup from "@/pages/RestaurantSignup";
import ResetPassword from "@/pages/ResetPassword";
import Legal from "@/pages/Legal";
import { privacyDoc } from "@/constants/legalPrivacy";
import { termsDoc } from "@/constants/legalTerms";
import Marketplace from "@/pages/Marketplace";
import HowItWorks from "@/pages/HowItWorks";
import Services from "@/pages/Services";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 120);
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-white text-[#0F172A]">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/buyer-waitlist" element={<BuyerWaitlist />} />
            <Route path="/become-a-vendor" element={<BecomeVendor />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/categories/:slug" element={<CategoryPage />} />
            <Route path="/restaurant-signup" element={<RestaurantSignup />} />
            <Route path="/admin/reset" element={<ResetPassword />} />
            <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
            <Route path="/terms" element={<Navigate to="/terms-and-conditions" replace />} />
            <Route path="/privacy-policy" element={<Legal title="AFLIMART Privacy Policy" doc={privacyDoc} />} />
            <Route path="/terms-and-conditions" element={<Legal title="AFLIMART Terms & Conditions" doc={termsDoc} />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/services" element={<Services />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid #E2E8F0",
            color: "#0F172A",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
